module.exports = __webpack_public_path__ + "img/arrow_left.5d147c34.svg";